import React from 'react';
import { Tooltip, Button } from 'antd';
import { useAtom } from 'jotai';
import { VerticalAlignMiddleOutlined } from '@ant-design/icons';
import { YAxisButton, StyledTooltip } from './styled';
import { yScaleModeAtom } from '@src/components/metrics-panel-hz/atoms';
import apptracker from '@utils/sensor/apptracker';
import { AUTO_Y_AXIS_TOGGLE } from '@src/utils/sensor/track';
import { TRENDS_DYNAMIC_Y_AXIS_HELP } from '@src/utils/help/links';

const AutoYAxisControl = () => {
  const [yScaleMode, setYScaleMode] = useAtom(yScaleModeAtom);

  const toggleYMode = () => {
    apptracker(AUTO_Y_AXIS_TOGGLE, { yScaleMode: !yScaleMode });
    setYScaleMode((prev) => !prev);
  };

  const title = () => {
    return (
      <StyledTooltip>
        <span>Dynamic Y-Axis</span>
        <Button type="link" href={TRENDS_DYNAMIC_Y_AXIS_HELP} target="_blank">
          Learn more
        </Button>
      </StyledTooltip>
    );
  };

  return (
    <Tooltip title={title}>
      <YAxisButton
        type={yScaleMode ? `primary` : 'default'}
        onClick={toggleYMode}
        icon={<VerticalAlignMiddleOutlined />}
      />
    </Tooltip>
  );
};

export default AutoYAxisControl;
